import { BsApple } from "react-icons/bs";
import { IoMdCheckmark } from "react-icons/io";
import { FaUserCircle, FaCartPlus, FaCreditCard, FaToolbox } from 'react-icons/fa';
import { MdAdd } from "react-icons/md";
import { MdHorizontalRule } from "react-icons/md";
import { useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import svg1 from "../../assets/Path 3376.svg";
import svg2 from "../../assets/Path 3377.svg";
import playstore from "../../assets/playstore.svg";
import illustration from "../../assets/illustration.svg";
import arrow from "../../assets/Vector.svg";
import download from "../../assets/download.svg";
import onboarding from "../../assets/Onboarding.svg";
import transactions from "../../assets/transactions.svg";
import card from "../../assets/card.png";
import deposit from "../../assets/deposit 1.png";
import bankTransfer from "../../assets/bank-transfer 1.png";
import sticky from "../../assets/sticky-note 1.png";
import { CSSProperties } from "react";
import { fakeFAQData } from "./data";
import Header from "../../components/Header";
import { Helmet } from "react-helmet";

const renderIcon = (iconName: string) => {
  switch (iconName) {
    case 'FaCartPlus':
      return <FaCartPlus className="mr-[20px] lg:w-[18px] lg:h-[18px] mt-1  ms:text-sm" />;
    case 'FaCreditCard':
      return <FaCreditCard className="mr-[20px] lg:w-[18px] lg:h-[18px] mt-1  ms:text-sm" />;
    case 'FaToolbox':
      return <FaToolbox className="mr-[20px] lg:w-[18px] lg:h-[18px] mt-1  ms:text-sm"/>
    default:
      return <FaUserCircle className="mr-[20px] lg:w-[18px] lg:h-[18px] mt-1  ms:text-sm" />;
  }
};

const Homepage = () => {
  const isSmallScreen = useMediaQuery("(max-width: 825px)");
  const [showSection, setShowSection] = useState<{ [key: string]: boolean}>({});
  const [showAnswer, setShowAnswer] = useState<{ [key: string]: boolean }>({});

  const clickAnswer =(id: string)=> {
    setShowAnswer({
      ...showAnswer,
      [id]:!showAnswer[id]
    })
  }

  const clickSection =(sectionId: string)=> {
    setShowSection({
      ...showSection,
      [sectionId]: !showSection[sectionId]
    });
  }

  const style: CSSProperties = { visibility: showAnswer.isHidden ? 'hidden' : 'visible' };

  return (
    <div className=" w-full ms:w-auto">
      <Helmet>
            <title>Swop</title>
      </Helmet>
      <Header />
      <div>
      <section id="home" className="flex lg:mt-20 md:mt-12 ms:mt-10 flex-row justify-evenly lg:w-full  mb-[104px] bg-sky-50">
        <div className="mt-20 w-full flex-row justify-evenly flex">
        <div className="flex flex-col lg:w-[611px] md:w-[58%] ms:w-[83.7%] items-center">
          <div className="flex flex-col w-full items-center">
            <div className="xl:w-[611px] text-black xl:text-5xl font-bold lg:text-left ms:text-center md:w-[390px] md:text-2xl">
              Make Simple, Seamless, and Secure Payments
            </div>
            <div className="flex flex-row mt-[20px] justify-between ms:w-[295px] xl:w-[611px] lg:w-[450px]">
            <a href="https://play.google.com/store/apps/details?id=com.swops&hl=en" target="_blank" rel="noopener noreferrer">
              <div  className="lg:w-[250px] cursor-pointer lg:h-20 ms:w-[120px] ms:h-[50px] bg-indigo-950 rounded-[50px] items-center flex flex-row">
                <img
                  className="lg:ml-[38px] ms:ml-[15px] ms:h-[15px] lg:mr-[15px] ms:mr-[5px] h-10 lg:h-8"
                  src={playstore}
                  alt=""
                />
                <div className="text-white lg:text-[20px] lg:w-[133px] ms:w-[100px] ms:text-[12px] ms:font-normal lg:font-bold">
                  Get it on Google Play
                </div>
              </div>
              </a>
              <a href="https://apps.apple.com/ng/app/swop-by-spay/id6566184865" target="_blank" rel="noopener noreferrer">
                <div className="lg:w-[250px] cursor-pointer lg:h-20 ms:w-[120px] ms:h-[50px] bg-indigo-950 rounded-[50px] items-center flex flex-row">
                  <BsApple className="text-white text-4xl lg:ml-[38px] ms:ml-[1px] ms:h-[15px] lg:mr-[15px] ms:mr-[5px] h-10 lg:h-8" />
                  <div className=" text-white lg:text-[20px] lg:w-[133px] ms:w-[70px] ms:text-[12px] ms:font-normal lg:font-bold">
                    Get it on App Store
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div className="w-full sm:w-4/5 md:w-4/5 lg:w-4/5 xl:w-4/5 flex flex-col items-center">
            <img
              src={svg1}
              alt="Logo"
              className="ms:w-[220px] ms:h-[120px] lg:w-[407.6px] lg:h-[195px] mt-[50px]"
            />
            <div className="text-center mt-[35px] text-black lg:text-4xl ms:text-[18px] font-sans font-bold">
              Who we are
            </div>
            <div className="w-full lg:max-w-[537px] mt-[10px] text-justify text-black ms:text-[16px] lg:text-[20px] ms:font-[400] lg:font-medium">
              At Swop, we redefine the way you experience financial transactions with our innovative wallet application. As a cutting-edge fin-tech solution, Swop is dedicated to providing a seamless and secure platform for managing your digital finances. Our commitment lies in simplifying the complexities of modern-day transactions, offering a one-stop solution for storing, managing, and utilizing various payment methods effortlessly.
            </div>
            <img
              src={svg2}
              alt="Logo"
              className="ms:w-[220px] ms:h-[120px] lg:w-[407.6px] lg:h-[195px] mt-[35px]"
            />
          </div>


        </div>
        {isSmallScreen ? "" : <div className="flex lg:w-[37%] md:w-[42%] justify-center bg-purple-50">
          <img
            className="lg:w-[543.04px] lg:h-[1177px] md:w-[90%] md:h-[800px]  rounded-[22.35px] shadow"
            src="/swopapp.png"
            alt=""
          />
        </div>}
        </div>
      </section>

      <section id="features" className="flex flex-col w-full items-center bg-white lg:h-[1323px] ms:h-auto">
        <div className="text-indigo-950 lg:text-[32px] font-semibold mt-4 mb-8 ms:text-[16px] ms:mt-[25px] ms:mb-[20px] ms:mt-[10px]">
          Our Features
        </div>
        <div className="lg:w-full ms:w-[400px] mt-[20px] text-center text-black lg:text-[40px] ms:text-[16px] ms:font-medium lg:font-semibold">
          Experience the many benefits of wallet application with swop
        </div>
        <div className="flex wt-[90%] mt-[50px] ms:mb-[50px] flex-row">

          <div className="flex flex-col justify-around lg:mr-[94px] ms:mr-[-54px] w-[166px] h-[890]">
            <img src={card} alt="card" className="lg:w-[160px] ms:w-[63px] lg:h-[160px] ms:h-[60px]"/>
            <img src={bankTransfer} alt="card" className="lg:w-[160px] ms:w-[63px] lg:h-[160px] ms:h-[60px]"/>
            <img src={deposit} alt="card" className="lg:w-[160px] ms:w-[63px] lg:h-[140px] ms:h-[60px]"/>
            <img src={sticky} alt="card" className="lg:w-[160px] ms:w-[63px] lg:h-[140px] ms:h-[60px]"/>
          </div>

          <div className="flex flex-row w-[60px] mt-50 h-[810px] relative">
            <div className="absolute left-[30px] top-[60px] w-[1px] h-[228px] bg-gray-500" />
            <div className="absolute left-[30px] top-[234px] w-[1px] h-[228px] bg-gray-500" />
            <div className="absolute left-[30px] top-[449px] w-[1px] lg:h-[328px] ms:h-[450px] bg-gray-500" />
            <div className="lg:w-[60px] ms:w-[23.7px] lg:h-[60px] ms:h-[23.7px] lg:left-0 ms:left-5 lg:top-0 ms:top-10 absolute bg-indigo-950 rounded-[50px] flex items-center justify-center">
              <div className="text-white lg:text-2xl ms:text-[10px] font-normal font-['Rubik']">1</div>
            </div>

            <div className="lg:w-[60px] ms:w-[23.7px] lg:h-[60px] ms:h-[23.7px] lg:left-0 ms:left-5 top-[242px] absolute bg-indigo-950 rounded-[50px] flex items-center justify-center">
              <div className="text-white lg:text-2xl ms:text-[10px] font-normal font-['Rubik']">2</div>
            </div>

            <div className="lg:w-[60px] ms:w-[23.7px] lg:h-[60px] ms:h-[23.7px] lg:left-0 ms:left-5 top-[484px] absolute bg-indigo-950 rounded-[50px] flex items-center justify-center">
              <div className="text-white lg:text-2xl ms:text-[10px] font-normal font-['Rubik']">3</div>
            </div>

            <div className="lg:w-[60px] ms:w-[23.7px] lg:h-[60px] ms:h-[23.7px] lg:left-0 ms:left-5 top-[726px] absolute bg-indigo-950 rounded-[50px] flex items-center justify-center">
              <div className="text-white lg:text-2xl ms:text-[10px] font-normal font-['Rubik']">4</div>
            </div>
          </div>

          <div className="lg:w-[496px] ms:w-[196px] h-[884px] relative">
            <div className="ms:w-[197px] lg:w-[496px] h-[133px] lg:left-[137px] ms:left-[-5px] top-[] absolute">
              <div className="left-0 top-0 absolute text-center text-black lg:text-[35px] ms:text-[14px] font-normal font-['Rubik'] tracking-tight">
                Secured Transactions
              </div>
              <div className="lg:w-[496px] ms:w-[185px] left-0 top-[61px] absolute text-zinc-500 lg:text-xl ms:text-[12px] lg:font-medium ms:font-[300] font-['Rubik'] tracking-tight">
                Your transactions are safeguarded with cutting-edge security
                measures, providing a worry-free environment for secure and
                protected financial interactions.
              </div>
            </div>
            <div className="ms:w-[197px] lg:w-[496px] h-[133px] lg:left-[137px] ms:left-[-5px] top-[509px] absolute">
              <div className="left-0 top-0 absolute text-black lg:text-[35px] ms:text-[14px] font-normal font-['Rubik'] tracking-tight">
                Easy Deposit
              </div>
              <div className="lg:w-[496px] ms:w-[185px] left-0 top-[61px] absolute text-zinc-500 lg:text-xl ms:text-[12px] lg:font-medium ms:font-[300] font-['Rubik'] tracking-tight">
                Simplify your fund management with hassle-free deposit options,
                making it convenient to add funds to your wallet whenever you
                need.
              </div>
            </div>
            <div className="ms:w-[197px] lg:w-[496px] h-[133px] lg:left-[137px] ms:left-[-5px] top-[751px] absolute">
              <div className="left-0 top-0 absolute text-black lg:text-[35px] ms:text-[14px] font-normal font-['Rubik'] tracking-tight">
                Easy to use
              </div>
              <div className="lg:w-[496px] ms:w-[185px] left-0 top-[61px] absolute text-zinc-500 lg:text-xl ms:text-[12px] lg:font-medium ms:font-[300] font-['Rubik'] tracking-tight">
                Streamline your financial experience with a user-friendly
                interface, ensuring effortless navigation and accessibility for
                users of all levels.
              </div>
            </div>
            <div className="ms:w-[197px] lg:w-[496px] h-[133px] lg:left-[137px] ms:left-[-5px] top-[267px] absolute">
              <div className="left-0 top-0 absolute text-black lg:text-[35px] ms:text-[14px] font-normal font-['Rubik'] tracking-tight">
                Quick Transfer
              </div>
              <div className="lg:w-[496px] ms:w-[185px] left-0 top-[61px] absolute text-zinc-500 lg:text-xl ms:text-[12px] lg:font-medium ms:font-[300] font-['Rubik'] tracking-tight">
                Experience rapid and efficient money transfers, enabling swift and
                seamless transactions for your convenience.
              </div>
            </div>
          </div>

        </div>
      </section>

      <section id="pricing" className="flex flex-col lg:h-[900px] ms:h-[635px] w-full items-center bg-sky-50">
        <div className="text-indigo-950 lg:text-[32px] font-semibold mt-4 mb-8 ms:text-[16px] ms:mt-[25px] ms:mb-[20px] ms:mt-[10px]">
          Our Offer
        </div>
        <div className="lg:w-[69.9%] text-center text-black lg:text-[40px] font-semibold ml:text-[24px] ms:text-[20px] break-words ms:w-full">
          Choose what is convenient
        </div>
        <div className="flex lg:flex-row  lg:mb-[159px] ms:flex-col ms:items-center lg:mt-[59px] ms:mt-[43px] w-full justify-evenly">
          <div className="lg:w-[550px] lg:h-[500px] lg:mt-[30px] ms:w-[360px] ms:h-[200px] bg-blue-100 rounded-[25px] flex flex-col items-center filter drop-shadow-[0px 4px 4px rgba(0, 0, 0, 0.25)]">
            <div className=" text-2xl ms:text-[16px] font-bold font-['Rubik'] lg:mt-[54px] lg:mb-[73px]" style={{color: '#3498DB'}}>
              Swop to Local Banks Transfer 
            </div>
            <div className="flex flex-row lg:w-[480px] ms:w-[320px] justify-between lg:mb-[50px] ms:mt-[28px] ms:mb-[20px]">
              <div className="flex flex-row">
                <IoMdCheckmark className="text-cyan-300 text-2xl font-bold ms:hidden lg:block" />
                <div className="text-black lg:text-xl ms:text-[14px] font-medium font-['Rubik'] tracking-tight lg:max-w-[280px] ms:max-w-[205px] lg:ml-[24px]">
                  Transfers below NGN 5,000 -
                </div>
              </div>
              <div className="text-black lg:text-2xl ms:text-[16px] font-bold font-['Rubik']">
                NGN 20
              </div>
            </div>
            <div className="flex flex-row lg:w-[480px] ms:w-[320px] justify-between lg:mb-[50px] ms:mb-[20px]">
              <div className="flex flex-row">
                <IoMdCheckmark className="text-cyan-300 text-2xl font-bold ms:hidden lg:block" />
                <div className="text-black lg:text-xl ms:text-[14px] font-medium font-['Rubik'] tracking-tight lg:max-w-[280px] ms:max-w-[205px] lg:ml-[24px]">
                  Transfers between NGN 5,001 and NGN 50,000
                </div>
              </div>
              <div className="text-black lg:text-2xl ms:text-[16px] font-bold font-['Rubik']">
                NGN 42
              </div>
            </div>
            <div className="flex flex-row lg:w-[480px] ms:w-[320px] justify-between lg:mb-[50px] ms:mb-[20px]">
              <div className="flex flex-row">
                <IoMdCheckmark className="text-cyan-300 text-2xl font-bold ms:hidden lg:block" />
                <div className="text-black lg:text-xl ms:text-[14px] font-medium font-['Rubik'] tracking-tight lg:max-w-[280px] ms:max-w-[205px] lg:ml-[24px]">
                  Transfers above NGN 50,000
                </div>
              </div>
              <div className="text-black lg:text-2xl ms:text-[16px] font-bold font-['Rubik']">
                NGN 50
              </div>
            </div>
          </div>
          <div className="lg:w-[550px] lg:h-[500px] ms:w-[360px] ms:mt-[50px] ms:h-[200px] bg-slate-400 rounded-[25px] flex flex-col items-center filter drop-shadow-[0px 4px 4px rgba(0, 0, 0, 0.25)]">
            <div className="text-white text-2xl ms:text-[16px] font-bold font-['Rubik'] lg:mt-[54px] lg:mb-[73px]">
              Swop to Swop Transfer
            </div>
            <div className="flex flex-row lg:w-[480px] ms:w-[320px] justify-between lg:mb-[50px] ms:mt-[28px] ms:mb-[20px]">
              <div className="flex flex-row">
                <IoMdCheckmark className="text-pink-200 text-2xl font-bold ms:hidden lg:block" />
                <div className="text-white lg:text-xl ms:text-[14px] font-medium font-['Rubik'] tracking-tight lg:max-w-[280px] ms:max-w-[205px] lg:ml-[24px]">
                  Transfers below NGN 5,000
                </div>
              </div>
              <div className="text-white lg:text-2xl ms:text-[16px] font-bold font-['Rubik']">
                Free
              </div>
            </div>
            <div className="flex flex-row lg:w-[480px] ms:w-[320px] justify-between lg:mb-[50px] ms:mb-[20px]">
              <div className="flex flex-row">
                <IoMdCheckmark className="text-pink-200 text-2xl font-bold ms:hidden lg:block" />
                <div className="text-white lg:text-xl ms:text-[14px] font-medium font-['Rubik'] tracking-tight lg:max-w-[280px] ms:max-w-[205px] lg:ml-[24px]">
                  Transfers between NGN 5,001 and NGN 50,000
                </div>
              </div>
              <div className="text-white lg:text-2xl ms:text-[16px] font-bold font-['Rubik']">
                NGN 10
              </div>
            </div>
            <div className="flex flex-row lg:w-[480px] ms:w-[320px] justify-between lg:mb-[50px] ms:mb-[20px]">
              <div className="flex flex-row">
                <IoMdCheckmark className="text-pink-200 text-2xl font-bold ms:hidden lg:block" />
                <div className="text-white lg:text-xl ms:text-[14px] font-medium font-['Rubik'] tracking-tight lg:max-w-[280px] ms:max-w-[205px] lg:ml-[24px]">
                  Transfers above NGN 50,000
                </div>
              </div>
              <div className="text-white lg:text-2xl ms:text-[16px] font-bold font-['Rubik']">
                NGN 20
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="about" className="flex flex-col w-full items-center bg-white">
        <div className="text-indigo-950 lg:text-[32px] font-semibold mt-4 ms:text-[16px] ms:mt-[25px] ms:mb-[20px] ms:mt-[10px] lg:mb-[53px]">
          How it works
        </div>
        <div className="flex lg:flex-row ms:flex-col lg:w-[961px] ms:w-full justify-between lg:mb-[53px]">
          <div className="flex flex-col items-center">
            <div className="lg:w-[98.04px] md:w-auto md:h-auto sm:w-auto sm:h-auto lg:h-[100px] relative">
              <img src={download} alt="" />
            </div>
            <div className="text-black lg:text-xl ms:text-lg font-medium font-['Rubik'] tracking-tight mt-[27px] mb-[27px]">
              Download the App
            </div>
            <div className="w-[252px] text-center text-zinc-500 lg:text-base ms:text-sm font-normal font-['Rubik'] tracking-wide">
              Download the application from App store or Google Play to continue
            </div>
            <div>
              <img
                src={arrow}
                alt=""
                className="lg:w-full ms:w-3/5 lg:rotate-0 ms:rotate-90 ms:mb-[20px] ms:mt-[10px]"
              />
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-[98.04px] h-[100px] md:w-auto md:h-auto sm:w-auto sm:h-auto relative">
              <img src={onboarding} alt="" />
            </div>
            <div className="text-black lg:text-xl ms:text-lg font-medium font-['Rubik'] tracking-tight mt-[27px] mb-[27px]">
              Complete onboarding
            </div>
            <div className="w-[252px] text-center text-zinc-500 lg:text-base ms:text-sm font-normal font-['Rubik'] tracking-wide">
              Complete the KYC and provide your required details to onboard and
              create account
            </div>
            <div>
              <img
                src={arrow}
                alt=""
                className="lg:w-full ms:w-3/5 lg:rotate-0 ms:rotate-90 ms:mb-[20px] ms:mt-[10px]"
              />
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-[98.04px] h-[100px] md:w-auto md:h-auto sm:w-auto sm:h-auto relative">
              <img src={transactions} alt="" className="" />
            </div>
            <div className="text-black lg:text-xl ms:text-lg font-medium font-['Rubik'] tracking-tight mt-[27px] mb-[27px]">
              Start making transactions
            </div>
            <div className="w-[252px] text-center text-zinc-500 lg:text-base ms:text-sm font-normal font-['Rubik'] tracking-wide">
              Login to your application and start enjoying the transaction
              features available
            </div>
            <div className="hidden md:block">
              <img
                src={arrow}
                alt=""
                className="lg:w-full ms:w-3/5 lg:rotate-0 ms:rotate-90 ms:mb-[20px] ms:mt-[10px]"
              />
            </div>
          </div>
        </div>
        <div className="flex lg:flex-row ms:flex-col justify-between lg:w-[1134px] ms:mt-[50px] mb-[21px] ms:w-[83.7%] items-center">
          <div className="lg:w-[537px] ms:w-[84.9%] h-[409px] ms:h-auto ms:p-0 pl-[69.43px] pr-[51.03px] pt-[16.53px] pb-[18.43px] bg-white justify-end items-center inline-flex">
            <img src={illustration} alt="" className="w-full" />
          </div>
          <div>
            <div className="lg:w-[330px] ms:w-[76.7%] text-black text-[35px] ml:text-[24px] ms:text-[22px] font-bold font-['Rubik'] tracking-tight">
              Wallet Applications.
            </div>
            <div className="lg:w-[598px] lg:mt-[22px] ms:mt-[10px] text-zinc-500 ms:text-[14px] ms:w-full text-base font-normal font-['Rubik'] tracking-wide break-words">
            Wallet applications, such as Swop, are indispensable tools in today's digital landscape, 
            revolutionizing the way we manage financial transactions. As the name implies, Swop serves 
            as a versatile platform accessible right from your smartphone, empowering users to streamline
             their payment processes effortlessly.
            </div>
            <div className="lg:w-[597px] mt-[22px] text-zinc-500 ms:text-[14px] text-base ms:w-full font-normal font-['Rubik'] tracking-wide break-words">
            One of the key advantages of Swop is its seamless and secure payment capabilities, whether it's 
            for online purchases or in-person transactions. By eliminating the reliance on physical cash or 
            carrying multiple banking cards, Swop simplifies the payment experience, offering peace of mind 
            to users while safeguarding their financial information.
            </div>
            <div className="lg:w-[597px] mt-[22px] text-zinc-500 ms:text-[14px] text-base ms:w-full font-normal font-['Rubik'] tracking-wide break-words">
            Beyond its core payment functionalities, Swop goes above and beyond by offering additional features 
            to enhance the user experience. These include robust transaction history tracking, empowering users 
            to monitor their spending patterns and identify areas for improvement.
            </div>
            <div className="lg:w-[597px] mt-[22px] text-zinc-500 ms:text-[14px] text-base ms:w-full font-normal font-['Rubik'] tracking-wide break-words">
            In essence, Swop embodies the essence of modern finance, combining convenience, security, and functionality 
            into a comprehensive solution for users' financial needs. With Swop in hand, users can navigate the digital 
            economy with confidence, knowing that their financial transactions are in safe and reliable hands.
            </div>
          </div>
        </div>
      </section>

      <section id="faq" className="lg:flex flex-col w-full bg-sky-50 items-center justify-center">
        <div className="text-indigo-950 lg:text-[32px] ms:text-[16px] text-center font-semibold mt-[35px] mb-[65px]">
          Frequently Asked Questions
        </div>
        <div
          className="lg:w-[86%] h-auto bg-sky-50 shadow mb-[100px] flex flex-col items-center justify-center"
          style={{ boxShadow: "0px 6px 30px 5px rgba(0, 0, 0, 0.12)" }}
        >
          <div className="w-[84.1%] mt-[34px] mb-[24px] break-words">
            {fakeFAQData.map((section) => (
              <div className="mb-[30px] border border-gray-300 rounded-lg p-3"> 
                <div className="flex flex-row cursor-pointer" onClick={()=> clickSection(`${section.id}`)} key={section.id}>
                {renderIcon(section.iconName)} 
                  <div className="text-black lg:text-[18px] ms:text-[15px] font-semibold font-['Rubik']">
                    {section.id}. {section.header}
                  </div>
                </div>
                {showSection[section.id] && (
                  <div className="ml-[40px]">
                    {section.subHeaders.map((item, index) => (
                      <div key={index}>
                        <div className={`cursor-pointer ml-[40px] self-center hover:h-auto hover:bg-white hover:shadow-lg flex items-center tracking-wide`} onClick={() => clickAnswer(`${section.id}-${index}`)}>
                          <div className="flex flex-col w-full rounded-lg p-4">
                            <div className="flex flex-row items-center justify-between">
                              {!showAnswer[`${section.id}-${index}`] ? 
                              <div className="text-black lg:text-base ms:text-sm font-medium font-['Rubik'] tracking-tight">
                              Q{index + 1}: {item.topic}
                            </div> :
                            <div className="text-blue-600 lg:text-base ms:text-sm font-medium font-['Rubik'] tracking-tight">
                            Q{index + 1}: {item.topic}
                          </div>
                            }
                              <div className="mt-[35px]">
                                {!showAnswer[`${section.id}-${index}`] ? (<MdAdd />) : <MdHorizontalRule />}
                              </div>
                            </div>
                            <div className={`w-[90.5%] mt-[24px] text-black text-sm items-center font-normal font-['Rubik'] break-words tracking-wide ${showAnswer[`${section.id}-${index}`] ? '' : 'hidden'}`}>
                              A: {item.answer}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

        </div>
      </section>
      </div>
    </div>
  );
};

export default Homepage;
